/// <reference path="./d/app.d.ts" />

declare var addFavoritePopup: any;

   class NotificationPopup {
        private $main: JQuery;
        private $addfavorite: JQuery;
        private cookieKey = 'notifications_enabled';
        private cookieClosedKey = 'notifications_closed';
        private cookiePopupOpened = 'notifications_popup_open';
        private cookieFavoriteAddedAlreadyKey = 'favorite_added_already';
        private cookieTimerInterrupt = 'notification_timer_interrupt';
        private publicVapidKey = 'BPM0aLxwjqjKvYPsKS26p3aNSirqpTQG6ICzZECBUMYoeZJiBf9kZvc2o-YD_ziF3DOeoLXos0rIXkHcAvmxZ7Y';
        private timerVariable;
        private $favImage: JQuery;
        private $favName: JQuery;
        private $mainOriginalDescription: JQuery;
        private $mainDeviceDescription: JQuery;
        private $mainSafariWarning: JQuery;
        private $addFavOriginalDescription: JQuery;
        private $addFavDeviceDescription: JQuery;
        private $addFavSafariWarning: JQuery;

        constructor() {
            this.$main = $('.notification-popup-main');
            this.$addfavorite = $('.notification-popup-addfavorite');

            // Main Buttons
            this.$main.find(".notification-accept-button").click(() => {
                this.$main.find(".notification-accept-button").prop('disabled', true);
                this.accept();
            });
            this.$main.find(".notification-close-button").click(() => {
                this.deny();
                this.hide();
            });

            // AddFavorite Buttons
            this.$addfavorite.find(".notification-accept-button").click(() => {
                this.$addfavorite.find(".notification-accept-button").prop('disabled', true);
                this.accept();
            });
            this.$addfavorite.find(".notification-close-button").click(() => {
                this.deny();
                this.setPopupOpenCookie(false);
                this.$addfavorite.hide();
            });

            // AddFavorite Performer Image
            this.$favImage = this.$addfavorite.find(".popup-icon-wrapper-emitter");

            // AddFavorite Performer Name
            this.$favName = this.$addfavorite.find(".notification-popup-addfavorite-performername");

            // Main Descriptions
            this.$mainOriginalDescription = this.$main.find(".notification-main-description");
            this.$mainDeviceDescription = this.$main.find(".notification-added-description");

            // AddFav Descriptions
            this.$addFavOriginalDescription = this.$addfavorite.find(".notification-main-description");
            this.$addFavDeviceDescription = this.$addfavorite.find(".notification-added-description");

            // Main Safari Warning
            this.$mainSafariWarning = this.$main.find(".notification-safari-warn");

            // AddFav Safari Warning
            this.$addFavSafariWarning = this.$addfavorite.find(".notification-safari-warn");
        }

        hasBeenAccepted() {
            const val = cookie.read(this.cookieKey);
            return !!val;
        }

        wasTimerInterrupted() {
            var val = cookie.read(this.cookieTimerInterrupt);

            return (val) ? true : false;
        }

        CheckMemberUsingMacbookWarning() {
            console.log("[TESTING_MAC]");

            var result = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

            return result;
        }

        // Handle the Message opener for main popup (if true)
        // Else for the secondary (favorite) popup.
        handleMacbookMessage(is_main) {
            var result_is_macuser = this.CheckMemberUsingMacbookWarning();

            if (result_is_macuser) {
                if (is_main) {
                    this.$main.find(".notification-macbook-warn").show();
                } else {
                    this.$addfavorite.find(".notification-macbook-warn").show();
                }
            }
        }

        // Handle the Message opener for main popup (if true)
        // Else for the secondary (favorite) popup.
        handleSafariMessage(is_main) {
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (isSafari) {
                if (is_main) {
                    this.$mainSafariWarning.show();

                    // Hide other Warnings and Descriptions
                    this.$main.find(".notification-macbook-warn").hide();
                    this.$mainDeviceDescription.hide();
                    this.$mainOriginalDescription.hide();
                } else {
                    this.$addFavSafariWarning.show();

                    // Hide other Warnings and Descriptions
                    this.$addfavorite.find(".notification-macbook-warn").hide();
                    this.$addFavDeviceDescription.hide();
                    this.$addFavOriginalDescription.hide();
                }
            }
        }

        // Handle the Message opener for main popup (if true)
        // Else for the secondary (favorite) popup.
        handleOtherDeviceMessage(is_main) {
            this.userHasOtherDeviceEnabled((data => {
                console.log(data);

                if (is_main) {
                    (data.has_other_devices) ? this.$mainOriginalDescription.hide() : this.$mainOriginalDescription.show();
                    (data.has_other_devices) ? this.$mainDeviceDescription.show() : this.$mainDeviceDescription.hide();
                } else {
                    (data.has_other_devices) ? this.$addFavOriginalDescription.hide() : this.$addFavOriginalDescription.show();
                    (data.has_other_devices) ? this.$addFavDeviceDescription.show() : this.$addFavDeviceDescription.hide();
                }
            }));
        }

        isNotDisabled() {
            const val = cookie.read(this.cookieClosedKey);

            // Check if we spend at least 7 days (1 week) since the date was closed.
            if (val !== undefined) {
                let unix_timestamp_number = Number(val);

                // Prepare the two dates (cookie set) && now.
                let date_closed = new Date(unix_timestamp_number);
                let date_now = new Date();

                // Calculate days spent since we set the cookie.
                let date_unix_diff = (date_closed.getTime() - date_now.getTime());
                let date_days = (date_unix_diff / (1000 * 3600 * 24));

                // If its more than 7 days, we can show the popup again.
                if (date_days >= 7) {
                    return true;
                } else {
                    return false;
                }
            } else {
                // Return true as the "closed" cookie was not set already.
                return true;
            }
        }

        showPopup(perfid) {
            if (!this.hasBeenAccepted() && !this.isPopupOpened()) {
                this.setPopupOpenCookie(true);
                this.handleOtherDeviceMessage(false);
                this.handleMacbookMessage(false);
                this.handleSafariMessage(false);
                this.getPerformerInformationsById(perfid);
                this.$addfavorite.show();
            }
        }

        showAddFavorite() {
            if (!this.hasBeenAccepted()) {
                this.userHasFavorites();
            }
        }

        // Validate if the user is currently viewing the roomlist or not.
        isViewvingLiveRoomList() {
            let SxcPathUrl = window.location.pathname;

            return (SxcPathUrl.indexOf("live") > -1) ? true : false;
        }

        // This "show" used to handle user-favorite task at a timely-matter
        // If you wish to "show" immediately, use the public showPopup() method.
        show() {
            // Execute popup after 30 seconds on the roomlist.
            if (this.isViewvingLiveRoomList() && this.verifyWhetherCanShow()) {
                this.timerVariable = setTimeout(() => {
                    if (!this.hasBeenAccepted() && !this.isPopupOpened() && this.isViewvingLiveRoomList() && this.verifyWhetherCanShow() && !this.wasTimerInterrupted()) {
                        this.userHasFavorites();
                    }
                }, 12000);
            }
        }

        stopNotificationDelayTimer() {
            console.log("[SXC_NOTIFICATION] The timer was interrupted.");

            cookie.erase("notifications_popup_open");
            clearTimeout(this.timerVariable);
        }

        private verifyWhetherCanShow() {
            let other_popup_classes = ["searchbg", "sxcc-topup-panel", "popup", "type-window"];

            // Loop over each and everything with these classes and look for display:
            // rulesets other than "none" (which means, another popup is up).
            for (let i = 0; i < other_popup_classes.length; i++) {
                var elements = document.getElementsByClassName(other_popup_classes[i]);
                var found_open = false;

                Array.from(elements).forEach((element, index) => {
                    if (window.getComputedStyle(element).display !== "none") {
                        console.log(element);
                        found_open = true;
                    }
                });

                if (found_open) {
                    return false;
                }
            }

            return true;
        }

        private getPerformerInformationsById(perfid) {
            var elemImage = this.$favImage;
            var elemName = this.$favName;

            $.ajax({
                url      : '/ajax/api/roomList/babes-get-performer',
                type     : 'POST',
                dataType : 'json',
                data     : {"perfid":perfid},
                success : function(data) {
                    elemImage.eq(0).css("background-image", 'url("' + data.performer_data.image + '")');
                    elemName.eq(0).html(data.performer_data.name);
                }
            });
        }

        private accept() {
            if ('serviceWorker' in navigator) {
                this.send(true).then(() => {
                    // Here we know the user has accepted the popup by the browser permission getter.
                    this.setCookie(false);
                    this.hide();
                    this.$addfavorite.hide();
                }).catch(err => console.error(err));
            } else {
                alert("Your browser does not support notifications, please either update or download the latest Google Chrome in order to get our notifications.");
            }
        }

        private deny() {
            cookie.create(this.cookieClosedKey, Date.now());
        }

        // Pass should_follow = true to set cookie for add_favorite_popup notifications
        // side-effect, when user don't have any favorites yet - we must force them to do so.
        private setCookie(should_follow) {
            if (should_follow) {
                cookie.create(this.cookieFavoriteAddedAlreadyKey, Date.now());
            } else {
                cookie.create(this.cookieKey, Date.now());
            }
        }

        // This cookie was tend to fix side-effects when probably two popups would come up
        // Eg. when user clicks "favorite" and 12 seconds later the delayed comes up.
        // State: true to create cookie, false to delete it.
        private setPopupOpenCookie(state) {
            if (state) {
                cookie.create(this.cookiePopupOpened, Date.now());
            } else {
                cookie.erase(this.cookiePopupOpened);
            }
        }

        // Can be used to check is popup is open.
        private isPopupOpened() {
            var val = cookie.read(this.cookiePopupOpened);

            return (val) ? true : false;
        }

        hide() {
            this.setPopupOpenCookie(false);
            this.$main.hide();
        }

        private userHasFavorites() {
            $.ajax({
                url: '/ajax/api/roomList/babes-get-favorites',
                type: 'GET',
                dataType: 'json',
                data: {}
            }).done((responseJSON) => {
                if (responseJSON.hasOwnProperty("user_favorites")) {
                    // If the response array contains elements, then we know the user have at least one fav.
                    // If no, tell them to add one.
                    this.setPopupOpenCookie(true);
                    this.handleOtherDeviceMessage(true);
                    this.handleMacbookMessage(true);
                    this.handleSafariMessage(true);
                    this.$main.show();
                } else {
                    console.log("[NOTIFICATION] Error while performing ajax call to /babes-get-favorites.");
                }
            });
        }

        private userHasOtherDeviceEnabled(cb) {
            fetch('/ajax/api/roomList/babes-get-notificationdevices',
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then((response) => {
                return response.json();
            }).then((data) => {
                cb(data);
            })
            .catch(error => console.warn(error));
        }

        async send( turnonnotif:boolean = false) {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
                console.log("Notification permission granted");
                // @ts-ignore
                window.initFirebaseWebpush(turnonnotif);
            }else{
                console.log("Notification permission denied");
                // @ts-ignore
                window.checkFirebasePermissionDenied();
            }

            //Old service:
            /*const register = await navigator.serviceWorker.register('/service-worker.js', {
                scope: '/'
            });

            await navigator.serviceWorker.ready;

            let subscription = await register.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: this.urlBase64ToUint8Array(this.publicVapidKey)
            });

            let subscription_data = await this.appendVariables(subscription);

            $.ajax({
                url: '/ajax/api/roomList/babes-get-notification-subscribe',
                type: 'POST',
                dataType: 'json',
                data: subscription_data,
                success: function (data) {
                    console.log('Data: ' + JSON.stringify(data));
                },
                error: function (request, error) {
                    console.log();
                }
            });*/
        }

        checkIfDeviceIsMobile() {
            let isMobile = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobile = true; })
                (navigator.userAgent || navigator.vendor);
            return isMobile;
        };

        async appendVariables(subscription) {
            var temp_subscription = JSON.stringify(subscription);
            var temp_subscription_json = JSON.parse(temp_subscription);

            const isMobile = "true";
            const userAgent = navigator.userAgent;

            var res_subscription = {
                endpoint: temp_subscription_json.endpoint,
                expiration: temp_subscription_json.expiration,
                p256dh: temp_subscription_json.keys.p256dh,
                auth: temp_subscription_json.keys.auth,
                is_mobile: isMobile,
                user_agent: userAgent
            };

            return res_subscription;
        }

        urlBase64ToUint8Array(base64String) {
            const padding = "=".repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, "+")
                .replace(/_/g, "/");

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }
    }

